export const compressImage = (file, maxWidth = 1024, quality = 0.9) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      // Calculate new dimensions while maintaining aspect ratio
      let { width, height } = img;

      // Only resize if image is larger than maxWidth
      if (width > maxWidth || height > maxWidth) {
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxWidth) {
            width = (width * maxWidth) / height;
            height = maxWidth;
          }
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Use better quality settings for compression
      if (ctx) {
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, width, height);
      }

      // Use higher quality for Kontext API
      const compressedDataUrl = canvas.toDataURL("image/jpeg", quality);

      console.log(
        `Compressed image: ${file.name}, original: ${img.width}x${img.height}, compressed: ${width}x${height}`
      );

      resolve(compressedDataUrl);
    };

    img.onerror = () => {
      console.error("Failed to load image for compression:", file.name);
      reject(new Error(`Failed to load image: ${file.name}`));
    };

    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target?.result;
    };
    reader.onerror = () => {
      console.error("Failed to read file:", file.name);
      reject(new Error(`Failed to read file: ${file.name}`));
    };
    reader.readAsDataURL(file);
  });
};
